import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout'; // Layout baru kita
import HomePage from './pages/HomePage';
import CreateAgentPage from './pages/CreateAgentPage';
import MyAgentsPage from './pages/MyAgentsPage';
import DashboardPage from './pages/DashboardPage';
import ComingSoonPage from './pages/ComingSoonPage';
import RunAgentPage from './pages/RunAgentPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ProfilePage from './pages/ProfilePage';

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/create-agent", element: <CreateAgentPage /> },
      { path: "/my-agents", element: <MyAgentsPage /> },
      { path: "/analytics", element: <AnalyticsPage /> },
      { path: "/profile", element: <ProfilePage /> },
      { path: "/agent/:agentId/run", element: <RunAgentPage /> },
      { path: "*", element: <ComingSoonPage /> }
    ],
  },
]);

export const AppRouter = () => <RouterProvider router={router} />;